import PropTypes from 'prop-types';
import { Suspense, useEffect, useRef, useState } from 'react';

const LazyComponent = ({
	importFunc,
	rootMargin = '0px',
	fallback = null,
	placeholder = null,
	placeholderPadding = '0px',
	componentProps = {}
}) => {
	const [Component, setComponent] = useState(null);
	const [loaded, setLoaded] = useState(false);
	const triggerRef = useRef(null);

	const importFuncRef = useRef(importFunc);
	importFuncRef.current = importFunc;

	useEffect(() => {
		const observer = new IntersectionObserver(
			entries => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						importFuncRef.current().then(mod => {
							setComponent(() => mod.default ?? mod);
							setLoaded(true);
						});
						observer.disconnect();
					}
				});
			},
			{ rootMargin }
		);

		if (triggerRef.current) {
			observer.observe(triggerRef.current);
		}

		return () => observer.disconnect();
	}, [rootMargin]);

	if (loaded && Component) {
		return (
			<Suspense fallback={fallback}>
				<Component {...componentProps} />
			</Suspense>
		);
	}

	return (
		<>
			<div ref={triggerRef}>
				{loaded && Component ? (
					<Suspense fallback={fallback}>
						<Component {...componentProps} />
					</Suspense>
				) : (
					placeholder
				)}
			</div>
			{!Component && <div style={{ paddingBottom: placeholderPadding }}></div>}
		</>
	);
};

LazyComponent.propTypes = {
	importFunc: PropTypes.func.isRequired,
	rootMargin: PropTypes.string,
	fallback: PropTypes.node,
	placeholder: PropTypes.node,
	placeholderPadding: PropTypes.string,
	componentProps: PropTypes.object
};

export default LazyComponent;
